import { X } from 'lucide-react';
import { formatDate, getUserTimezone } from '../../utils/dateFormat';

interface SalesforceStatusPanelProps {
  isLoading: boolean;
  statusData: {
    salesforce_status: string | null;
    last_modified: string | null;
  } | null;
  onClose: () => void;
}

export function SalesforceStatusPanel({
  isLoading,
  statusData,
  onClose,
}: SalesforceStatusPanelProps) {
  return (
    <div className="mb-4 bg-white dark:bg-dark-elevated border border-gray-200 dark:border-dark-border rounded-lg shadow-sm">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 dark:border-dark-border">
        <span className="text-sm font-medium text-gray-700 dark:text-gray-200">Salesforce Status</span>
        <button
          onClick={onClose}
          className="p-1.5 rounded-md hover:bg-gray-100 dark:hover:bg-dark-hover text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          title="Close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="px-4 py-3">
        {isLoading ? (
          <div className="flex items-center gap-2 text-gray-500 dark:text-gray-400 text-sm py-2">
            <span className="inline-block w-3 h-3 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
            Loading...
          </div>
        ) : statusData ? (
          <div className="space-y-1 text-sm">
            <div>
              <span className="text-gray-600 dark:text-gray-400">Status:</span>{' '}
              <span className="font-medium text-gray-800 dark:text-gray-200">{statusData.salesforce_status || 'N/A'}</span>
            </div>
            <div>
              <span className="text-gray-600 dark:text-gray-400">Last Modified:</span>{' '}
              <span className="font-medium text-gray-800 dark:text-gray-200">
                {formatDate(statusData.last_modified)}
              </span>
              <span className="text-xs text-gray-400 dark:text-gray-500 ml-1">
                ({getUserTimezone()})
              </span>
            </div>
          </div>
        ) : (
          <p className="text-gray-500 dark:text-gray-400 text-sm py-2">No Salesforce status available.</p>
        )}
      </div>
    </div>
  );
}
